module.exports = __webpack_public_path__ + "media/images/logo-white-old-450b92eb07ba57e78c15c50e185eb751.png";